import styled from "@emotion/styled";

export const Container = styled.div`
  display: flex;
  width: 100%;
  height: 114px;
  padding: 16px 20px;
  align-items: center;
  gap: 20px;
  box-sizing: border-box;

  border-radius: 12px;
  border: 1px solid var(--alias-color-line-normal);
  background: var(--alias-color-background-normal-normal);
`;

export const LeftContentContainer = styled.div`
  display: flex;
  width: 200px;
  flex-direction: column;
  align-items: flex-start;
  gap: 8px;
`;

export const RightContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 24px;
  flex: 1 0 0;
  align-self: stretch;
`;
